export default __webpack_public_path__ + "static/media/camera.0f5694bf.svg";